import React from "react";
import { useQuery } from "../../hooks/useQuery";
import gql from "graphql-tag";
import Error from "../QueryError";

export const GET_USERFLOW = gql`
  query ($projectId: String!, $url: String!) {
    userFlow {
      getUserFlowByUrl(projectId: $projectId, url: $url) {
        id
        title
        description
        userFlowSteps {
          id
          stepName
          description
          url
          isComplete
          lastViewedContentPage {
            id
            url
          }
          contentGroup {
            id
            url
            description
            type
            iconAsset {
              assetId
              contentType
              presignedUrl
              s3Key
            }
            contentPages(status: [UNPUBLISHED, PUBLISHED], topLevelOnly: true) {
              sort
              url
            }
          }
        }
      }
    }
  }
`;

const GetUserFlow = (props) => {
  const { onComplete, url, projectId } = props;
  const { error, data } = useQuery(GET_USERFLOW, {
    fetchPolicy: "network-only",
    variables: {
      url,
      projectId,
    },
  });

  const handleError = (error) => {
    onComplete(error, "error");
  };

  if (error) {
    onComplete(error.message, "error");
    return <Error message={error.message} onError={handleError} />;
  }
  if (data && Object.entries(data).length !== 0) {
    onComplete(data.userFlow.getUserFlowByUrl, "data");
    return null;
  }
  return <></>;
};

export default GetUserFlow;
